// extracted by mini-css-extract-plugin
export default {"box":"BoxInput_box__Nj4nr","input":"BoxInput_input__OAClN"};